var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Modal ModalInviteEmail"
  }, [_c('modal-background'), _c('div', {
    staticClass: "Modal__container whole"
  }, [_c('div', {
    staticClass: "Modal__top"
  }, [_c('p', [_vm._v(_vm._s(_vm.tt('이메일로 초대하기')))]), _c('button', {
    staticClass: "Modal__close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/close-popup.svg"),
      "alt": "closeBtn"
    }
  })])]), _c('div', {
    staticClass: "Modal__content"
  }, [_vm._l(_vm.emailList, function (item, index) {
    return _c('progress-input-auto-increment', {
      key: index,
      attrs: {
        "index": index,
        "length": _vm.emailList.length,
        "placeholder": '이메일',
        "isValid": _vm.isValid[index],
        "validText": _vm.validText[index]
      },
      on: {
        "update": _vm.updateEmail,
        "clickDelete": _vm.clickDeleteEmail
      },
      model: {
        value: _vm.emailList[index],
        callback: function ($$v) {
          _vm.$set(_vm.emailList, index, $$v);
        },
        expression: "emailList[index]"
      }
    });
  }), _c('button', {
    staticClass: "Btn__complete",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.tt('이메일 전송')) + " ")])], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }